import React from 'react'

import { Popconfirm } from 'antd'
import { Checkbox } from 'antd'

import { Attachment } from 'core/domain/expenses/attachment'

import Icon from 'common/components/general/Icon'

interface ImageProps {
  attachment: Attachment
  setAttachmentToPreview: (image: Attachment) => void
  deleteAttachment: (id: string) => void
  translate: (key: string) => string
}

const GalleryItem: React.FC<ImageProps> = ({ attachment, setAttachmentToPreview, deleteAttachment, translate }) => {
  return (
    <div
      className="position-relative gallery-item"
      style={{
        minHeight: '135px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Checkbox value={attachment.attachmentId} className="position-relative" key={attachment.attachmentId}>
        <div style={{ position: 'absolute', left: 0, top: 0 }}>
          <img src={attachment.fileNameUrl} alt={attachment.title} style={{ height: 'auto', width: '100%' }} />
        </div>
      </Checkbox>
      <div className="existing_image_action">
        <div
          style={{ cursor: 'pointer' }}
          onClick={(e) => {
            setAttachmentToPreview(attachment)
          }}
        >
          <Icon type="far fa-eye" className="white_icon" fontAwesome />
        </div>
        <Popconfirm
          title={translate('get-reimburse.request.remove-from-gallery-confirmation')}
          onConfirm={() => {
            deleteAttachment(attachment.attachmentId)
          }}
        >
          <div style={{ cursor: 'pointer' }}>
            <Icon type="far fa-trash-alt" className="white_icon" fontAwesome />
          </div>
        </Popconfirm>
      </div>
    </div>
  )
}

export default GalleryItem
